import "./i18n";
import WidgetHelper from "@/utils/widgetHelper.tsx";

WidgetHelper.initialize();
